import { userClickCancelBankVerificationAction, userClickContinueBankVerificationAction } from '@banking/ui/workflows/bank-accounts/cancel-verification';
import { workflowComponent } from '@banking/ui/services/cancel-verification-modal';
import { hbs } from 'ember-cli-htmlbars';

// Similar to Banking::BankAccounts::Connected::CancelVerificationModal
// but for the settings page. It shares the same underlying bank-accounts/cancel-verification workflow, but attaches it
// to a new standalone cancel-verification service.

const template = hbs`
  <Banking::BankAccounts::Modal
    @active={{this.showCancelVerificationModal}}
    @closeModal={{this.userClickContinueBankVerification}}
  >
    <Banking::BankAccounts::CancelVerification
      @isCancellingVerification={{this.isCancellingVerification}}
      @userClickContinueVerification={{this.userClickContinueBankVerification}}
      @userClickCancelVerification={{this.userClickCancelVerification}}
    />
  </Banking::BankAccounts::Modal>
`;
export const mapStateToProps = state => ({
  isCancellingVerification: state.isCancellingVerification,
  showCancelVerificationModal: state.isModalOpen
});
const mapActionsToProps = () => ({
  userClickContinueBankVerification: userClickContinueBankVerificationAction,
  userClickCancelVerification: userClickCancelBankVerificationAction
});
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);